"use client";

import { SDUIFilterablePaginatedSectionCategoryNavigationRenderer } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/CategoryNavigation/SDUIFilterablePaginatedSectionCategoryNavigationRenderer";
import { useFilterablePaginatedSectionQuery } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Fetching/useFilterablePaginatedSectionQuery";
import { SDUIFilterablePaginatedSectionCatNavigationLoadingSkeleton } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/LoadingSkeleton/SDUIFilterablePaginatedSectionCatNavigationLoadingSkeleton";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { IFilterablePaginatedSection } from "@faire/web-api--source/indigofair/data/IFilterablePaginatedSection";
import React from "react";

export const SDUIFilterablePaginatedSectionCategoryNavigationNonRSC: React.FC<{
  filterablePaginatedSection: IFilterablePaginatedSection;
}> = ({ filterablePaginatedSection }) => {
  const { isNavigationTreeLoading, navigationTreeData } =
    useFilterablePaginatedSectionQuery(filterablePaginatedSection);
  const isSSR = useIsSSR();

  if ((isNavigationTreeLoading && navigationTreeData === undefined) || isSSR) {
    return <SDUIFilterablePaginatedSectionCatNavigationLoadingSkeleton />;
  }

  return (
    <SDUIFilterablePaginatedSectionCategoryNavigationRenderer
      navigationTree={navigationTreeData}
    />
  );
};
